import { useState } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { MatchAdmin, ResultVerification } from '../../../models/interfaces/Match';
import OfficialVerificationAndFinishMatch from './OfficialVerificationAndFinishMatch';

interface Props {
    onHideModal: () => void;
    shouldShow: boolean;
    matchAdmin: MatchAdmin;
    matchOfficialVerification?: ResultVerification;
    handleReloadOfficialVerification: () => void;
}

const MatchOfficialVerificationModal = ({
    onHideModal,
    shouldShow,
    matchAdmin,
    matchOfficialVerification,
    handleReloadOfficialVerification,
}: Props) => {
    const [error, setError] = useState<string | undefined>(undefined);
    const [allowEdit, setAllowEdit] = useState<boolean>(false);

    const handleSubmit = (updateStatCallBack: () => void, verification?: ResultVerification) => {
        matchAdmin
            .updateResultVerification(verification)
            .catch((error) => {
                console.error(error);
                setError(error);
            })
            .finally(() => {
                updateStatCallBack();
                toggleEdit();
                handleReloadOfficialVerification();
            });
    };

    const toggleEdit = () => {
        setAllowEdit((state) => !state);
    };

    return (
        <Modal show={shouldShow} onHide={onHideModal}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {matchOfficialVerification
                        ? 'Official Verification'
                        : 'Add Official Verification'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {matchOfficialVerification && !allowEdit ? (
                    <>
                        <Row>
                            <Col>
                                <strong>Official Name</strong>
                            </Col>
                            <Col>
                                <strong>Official Email</strong>
                            </Col>
                        </Row>
                        <Row>
                            <Col>{matchOfficialVerification.officialName}</Col>
                            <Col>{matchOfficialVerification.email}</Col>
                        </Row>
                        <Row className="my-4 justify-content-center">
                            <Col xs="auto">
                                <img
                                    src={matchOfficialVerification.verificationObject}
                                    alt="Official Signature"
                                />
                            </Col>
                        </Row>
                    </>
                ) : (
                    <OfficialVerificationAndFinishMatch
                        handleBack={toggleEdit}
                        onSubmit={handleSubmit}
                        submissionError={error}
                        matchOfficialVerification={matchOfficialVerification}
                        // if we're in this modal it's because the match is complete
                        matchCompleted={true}
                        modalSize="small"
                        // needs to be provided separately as if we are coming from the editStat modal we won't provide this prop
                        removeBackButton={!matchOfficialVerification}
                    />
                )}
            </Modal.Body>
            {matchOfficialVerification && !allowEdit && (
                <Modal.Footer>
                    <Button variant="primary" onClick={toggleEdit}>
                        Edit Verification
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default MatchOfficialVerificationModal;
